export const CONFIG_VIEW_MODE = "CONFIG_VIEW_MODE";
export const CONFIG_DEFAULT_PAGE = "CONFIG_DEFAULT_PAGE";
